import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import TestCodeInput from '../pages/TestCodeInput';
import EmotionalMemoryPattern from '../pages/EmotionalMemoryPattern';
import BigFivePersonalityTest from '../pages/BigFivePersonalityTest';
import TalentTestIntro from '../pages/TalentTestIntro';
import TalentTestPage from '../pages/TalentTestPage';
import TalentTestResult from '../pages/TalentTestResult';

import AnalysisReport from '../pages/AnalysisReport';
import Admin from '../pages/Admin';
import AboutDeveloper from '../pages/AboutDeveloper';
import PersonalityDictionaryPage from '../pages/PersonalityDictionaryPage';
import BlogPost from '../pages/BlogPost';
import TeamCardWall from '../pages/TeamCardWall';
import MemberDetail from '../pages/MemberDetail';
import NotFound from '../pages/NotFound';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/test-code" element={<TestCodeInput />} />
      <Route path="/emotional-memory-pattern" element={<EmotionalMemoryPattern />} />
            <Route path="/big-five-personality" element={<BigFivePersonalityTest />} />
            <Route path="/talent-test-intro" element={<TalentTestIntro />} />
      <Route path="/talent-test" element={<TalentTestPage />} />
      <Route path="/talent-test-result" element={<TalentTestResult />} />
      
      <Route path="/analysis-report" element={<AnalysisReport />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/personality-dictionary" element={<PersonalityDictionaryPage />} />
      <Route path="/about-developer" element={<AboutDeveloper />} />
      <Route path="/blog/:id" element={<BlogPost />} />
      <Route path="/team/:teamId/member/:memberId" element={<MemberDetail />} />
      <Route path="/team/:teamId" element={<TeamCardWall />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;